import { useState } from "react";
import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "关于黑料王 - 娱乐圈黑料曝光平台",
  description: "黑料王是专注娱乐圈内幕、明星黑料曝光的权威平台，汇聚最新、最劲爆的圈内黑料资讯。",
  url: "https://heiliaowang.com/about",
  isPartOf: {
    "@type": "WebSite",
    name: "黑料王",
    url: "https://heiliaowang.com",
  },
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "黑料王的爆料内容真实可靠吗？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "黑料王所有爆料内容均来源于多方渠道的交叉验证。我们拥有专业的调查团队，对每一条信息进行严格的核实与把关，确保内容的真实性和可靠性。同时，我们也欢迎广大用户提供线索，共同维护一个真实可信的娱乐资讯平台。",
      },
    },
    {
      "@type": "Question",
      name: "如果发现不实内容，应该如何处理？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "如果您认为平台上的某些内容存在不实或侵权问题，可以通过页面底部的联系方式与我们取得联系。我们会在收到反馈后的24小时内进行核实，并在确认后立即处理相关内容。",
      },
    },
    {
      "@type": "Question",
      name: "如何向黑料王提供爆料线索？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "您可以通过邮箱 tips@heiliaowang.com 或微信公众号'黑料王'向我们提供爆料线索。我们承诺对所有爆料人的信息严格保密，并对有价值线索提供丰厚奖励。",
      },
    },
    {
      "@type": "Question",
      name: "黑料王每天更新多少内容？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "黑料王保持每日至少更新5-8篇独家爆料文章，涵盖明星黑料、恋情曝光、丑闻揭秘、综艺内幕、片场爆料等多个板块。重大事件发生时，我们会第一时间追踪报道，确保用户掌握最新动态。",
      },
    },
  ],
};

export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const faqs = [
    {
      q: "黑料王的爆料内容真实可靠吗？",
      a: "黑料王所有爆料内容均来源于多方渠道的交叉验证。我们拥有专业的调查团队，对每一条信息进行严格的核实与把关，确保内容的真实性和可靠性。同时，我们也欢迎广大用户提供线索，共同维护一个真实可信的娱乐资讯平台。",
    },
    {
      q: "如果发现不实内容，应该如何处理？",
      a: "如果您认为平台上的某些内容存在不实或侵权问题，可以通过页面底部的联系方式与我们取得联系。我们会在收到反馈后的24小时内进行核实，并在确认后立即处理相关内容。",
    },
    {
      q: "如何向黑料王提供爆料线索？",
      a: '您可以通过邮箱 tips@heiliaowang.com 或微信公众号“黑料王”向我们提供爆料线索。我们承诺对所有爆料人的信息严格保密，并对有价值线索提供丰厚奖励。',
    },
    {
      q: "黑料王每天更新多少内容？",
      a: "黑料王保持每日至少更新5-8篇独家爆料文章，涵盖明星黑料、恋情曝光、丑闻揭秘、综艺内幕、片场爆料等多个板块。重大事件发生时，我们会第一时间追踪报道，确保用户掌握最新动态。",
    },
  ];

  return (
    <>
      <SEO
        title="关于我们 - 黑料王"
        description="黑料王是专注娱乐圈内幕、明星黑料曝光的权威平台。了解黑料王的品牌故事、团队实力、用户口碑，以及联系方式。"
        keywords="黑料王,关于黑料王,娱乐八卦平台,娱乐圈内幕,联系我们"
        canonicalUrl="https://heiliaowang.com/about"
        schema={aboutSchema}
      />

      <div className="min-h-screen bg-background-950 flex flex-col">
        <Navbar />
        <main className="flex-1">
          <div className="w-full px-4 md:px-6 lg:px-8 max-w-4xl mx-auto">
            <section className="py-8 md:py-12" id="brand-intro">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-100 mb-6">
                关于黑料王
              </h1>

              <div className="bg-background-900 border border-background-800/60 rounded-lg p-6 md:p-8 mb-8">
                <h2 className="text-lg font-heading font-bold text-foreground-200 mb-4">品牌介绍</h2>
                <div className="space-y-4 text-sm text-foreground-400 leading-relaxed">
                  <p>
                    <strong className="text-foreground-200">黑料王</strong>成立于2024年，是国内领先的娱乐圈内幕资讯平台。我们致力于为广大网友提供最新、最全、最劲爆的娱乐圈黑料信息，深扒明星私下真实的一面。
                  </p>
                  <p>
                    在信息爆炸的时代，娱乐圈的各种传闻真假难辨。黑料王坚持<strong className="text-foreground-200">"只爆真料"</strong>的原则，组建了一支专业的娱乐调查团队，深入娱乐圈各个角落，为用户挖掘不为人知的真相。
                  </p>
                  <p>
                    我们的内容涵盖明星黑料、恋情曝光、丑闻揭秘、综艺内幕、片场爆料、私生活等多个板块，每日更新独家内容，让用户第一时间掌握圈内最新动态。截至目前，黑料王已累计发布超过5000篇独家爆料，吸引了数百万忠实用户。
                  </p>
                  <p>
                    黑料王团队由资深娱乐记者、调查编辑和数据分析师组成，平均从业经验超过8年。我们的使命是<strong className="text-foreground-200">打破娱乐圈的信息壁垒，让真相不再被掩盖</strong>。
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                <div className="bg-background-900 border border-background-800/60 rounded-lg p-5 text-center">
                  <div className="text-3xl font-heading font-bold text-primary-400 mb-1">5000+</div>
                  <p className="text-xs text-foreground-500">独家爆料文章</p>
                </div>
                <div className="bg-background-900 border border-background-800/60 rounded-lg p-5 text-center">
                  <div className="text-3xl font-heading font-bold text-accent-400 mb-1">300万+</div>
                  <p className="text-xs text-foreground-500">月活跃用户</p>
                </div>
                <div className="bg-background-900 border border-background-800/60 rounded-lg p-5 text-center">
                  <div className="text-3xl font-heading font-bold text-primary-400 mb-1">98.7%</div>
                  <p className="text-xs text-foreground-500">用户满意度</p>
                </div>
              </div>

              <div className="bg-background-900 border border-background-800/60 rounded-lg p-6 md:p-8 mb-8" id="reputation">
                <h2 className="text-lg font-heading font-bold text-foreground-200 mb-4">用户口碑</h2>
                <div className="space-y-4">
                  <div className="p-4 bg-background-800/50 rounded-lg">
                    <div className="flex items-center gap-1 mb-2">
                      {[1, 2, 3, 4, 5].map((i) => (
                        <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-300 mb-2">
                      "黑料王真的是娱乐圈的'纪检委'，很多在其他平台看不到的内幕，这里都有独家报道。每天早上起来第一件事就是刷黑料王，已经成习惯了！"
                    </p>
                    <p className="text-xs text-foreground-600">—— 资深八卦爱好者，使用2年</p>
                  </div>
                  <div className="p-4 bg-background-800/50 rounded-lg">
                    <div className="flex items-center gap-1 mb-2">
                      {[1, 2, 3, 4, 5].map((i) => (
                        <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-300 mb-2">
                      "作为一个媒体人，我很欣赏黑料王的专业度。每篇报道都有理有据，不是那种瞎编乱造的营销号能比的。在娱乐新闻这个领域，黑料王的可信度是最高的。"
                    </p>
                    <p className="text-xs text-foreground-600">—— 媒体从业者，使用1年</p>
                  </div>
                  <div className="p-4 bg-background-800/50 rounded-lg">
                    <div className="flex items-center gap-1 mb-2">
                      {[1, 2, 3, 4, 5].map((i) => (
                        <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-300 mb-2">
                      "内容更新快、爆料独家、界面也很清爽。之前推荐给朋友们，大家都说好。希望黑料王越办越好，继续产出更多优质内容！"
                    </p>
                    <p className="text-xs text-foreground-600">—— 忠实用户，使用1.5年</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-900 border border-background-800/60 rounded-lg p-6 md:p-8 mb-8" id="contact">
                <h2 className="text-lg font-heading font-bold text-foreground-200 mb-4">联系我们</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="p-4 bg-background-800/50 rounded-lg flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0">
                      <i className="ri-mail-line text-primary-400"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-200 mb-1">爆料邮箱</h4>
                      <p className="text-sm text-foreground-500">tips@heiliaowang.com</p>
                      <p className="text-xs text-foreground-600 mt-1">提供爆料线索（严格保密）</p>
                    </div>
                  </div>
                  <div className="p-4 bg-background-800/50 rounded-lg flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0">
                      <i className="ri-mail-send-line text-primary-400"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-200 mb-1">商务合作</h4>
                      <p className="text-sm text-foreground-500">biz@heiliaowang.com</p>
                      <p className="text-xs text-foreground-600 mt-1">广告投放与商业合作</p>
                    </div>
                  </div>
                  <div className="p-4 bg-background-800/50 rounded-lg flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0">
                      <i className="ri-wechat-line text-primary-400"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-200 mb-1">微信公众号</h4>
                      <p className="text-sm text-foreground-500">黑料王</p>
                      <p className="text-xs text-foreground-600 mt-1">搜索关注获取每日推送</p>
                    </div>
                  </div>
                  <div className="p-4 bg-background-800/50 rounded-lg flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0">
                      <i className="ri-customer-service-line text-primary-400"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-200 mb-1">内容申诉</h4>
                      <p className="text-sm text-foreground-500">appeal@heiliaowang.com</p>
                      <p className="text-xs text-foreground-600 mt-1">24小时内核实处理</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-900 border border-background-800/60 rounded-lg p-6 md:p-8" id="faq">
                <h2 className="text-lg font-heading font-bold text-foreground-200 mb-4">
                  常见问题
                </h2>
                <div className="space-y-3">
                  {faqs.map((faq, index) => (
                    <div key={index} className="border border-background-800/60 rounded-lg overflow-hidden">
                      <button
                        onClick={() => setOpenFaq(openFaq === index ? null : index)}
                        className="w-full flex items-center justify-between p-4 text-left cursor-pointer hover:bg-background-800/30 transition-colors duration-200"
                        aria-expanded={openFaq === index}
                      >
                        <span className="text-sm font-medium text-foreground-200 pr-4">
                          {faq.q}
                        </span>
                        <i
                          className={`text-foreground-500 transition-transform duration-200 text-sm flex-shrink-0 ${
                            openFaq === index ? "ri-subtract-line" : "ri-add-line"
                          }`}
                        ></i>
                      </button>
                      <div
                        className={`transition-all duration-300 overflow-hidden ${
                          openFaq === index ? "max-h-60" : "max-h-0"
                        }`}
                      >
                        <div className="px-4 pb-4 text-sm text-foreground-400 leading-relaxed">
                          {faq.a}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>

      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </>
  );
}